<template>
  <div class="card-content">
    <div class="mt-s">
      <div class="mb-5 w-full">
        <fieldset>
          <div class="form-group">
            <input
              v-model="searchQuery"
              type="search"
              class="form-control form-search"
              placeholder="Type to find what you are looking for"
              aria-controls="datatables"
              autofocus
            />
          </div>
        </fieldset>
      </div>

      <div>
        <el-table
          class="table-striped first-row-clicable"
          :data="queriedData"
          :default-sort="defaultSort"
          border
        >
          <el-table-column
            v-for="column in tableColumns"
            :key="column.label"
            sortable
            :sort-orders="['ascending', 'descending']"
            :min-width="column.minWidth"
            :prop="column.prop"
            :label="column.label"
          />

          <el-table-column label="Remove from group" header-align="center">
            <template #default="props">
              <div class="text-center">
                <p-checkbox
                  :value="props.row.id"
                  :class="{ disabled: isReadyToBeMoved(props.row.id) }"
                  :disabled="isReadyToBeMoved(props.row.id)"
                  @input="toggleRemove(props.row.id)"
                />
              </div>
            </template>
          </el-table-column>

          <el-table-column label="Move to group" header-align="center">
            <template #default="props">
              <div class="text-center">
                <el-select
                  v-model="model.move[props.row.id]"
                  filterable
                  clearable
                  class="select-primary"
                  :class="{ disabled: isReadyToBeRemoved(props.row.id) }"
                  size="large"
                  placeholder="Select a group"
                  :disabled="isReadyToBeRemoved(props.row.id)"
                  @change="
                    (groupId) => handleMoveToGroup(props.row.id, groupId)
                  "
                >
                  <el-option
                    v-for="option in availableGroups"
                    :key="option.name"
                    class="select-primary"
                    :value="option.id"
                    :label="option.name"
                  />
                </el-select>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- <div class="flex justify-between items-center">
        <div>
          <p class="category">
            Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
          </p>
        </div>

        <p-pagination
          v-model="pagination.currentPage"
          :per-page="pagination.perPage"
          :total="pagination.total"
        />

        <div>
          <el-select
            v-model="pagination.perPage"
            class="select-default"
            placeholder="Per page"
          >
            <el-option
              v-for="item in pagination.perPageOptions"
              :key="item"
              class="select-default"
              :label="item"
              :value="item"
            />
          </el-select>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import tableConfig from "@providers/table";
import joinByName from "@helpers/joinByName";
//import PPagination from "@components/UIComponents/Pagination.vue";
import { Table, TableColumn, Select } from "element-ui";
import Vue from "vue";
import _xor from "lodash.xor";
import { mapGetters, mapActions } from "vuex";
Vue.use(Table);
Vue.use(TableColumn);

export default {
  components: {
    //PPagination,
    [Select.name]: Select,
  },
  props: {
    trainees: {
      type: Array,
      default: () => [],
    },
  },
  emits: ["move", "remove"],
  data() {
    const table = {
      tableColumns: [
        {
          prop: "fullName",
          label: "Name",
          minWidth: 150,
        },
        // {
        //   prop: "rpe",
        //   label: "Registry, Purpose, Equipment",
        //   minWidth: 150
        // },
        // {
        //   prop: "roles",
        //   label: "Roles",
        //   minWidth: 100
        // }
      ],
    };

    const model = {
      remove: [],
      move: [],
    };

    return {
      model,
      availableGroups: [],
      ...table,
      ...tableConfig.data,
      defaultSort: { prop: "fullName", order: "ascending" },
    };
  },
  computed: {
    ...mapGetters("loadingStore", { isLoading: "loading" }),
    ...mapGetters("companyGroupStore", ["groups", "group"]),
    tableData() {
      const trainees = this.trainees;

      return trainees.map((trainee) => ({
        ...trainee,
        rpe: joinByName(trainee.company.rpe),
        roles: joinByName(trainee.company.roles),
      }));
    },
    ...tableConfig.computed,
  },
  async mounted() {
    try {
      this.$wait.start(this._uid);
      await this.getCompanyGroups();
      this.availableGroups = this.groups
        .filter(({ id }) => {
          return Number(id) !== Number(this.group.id);
        })
        .map((group) => {
          return {
            id: group.id,
            name: group.name,
          };
        });
      return;
    } catch (error) {
      this.addNewError(error);
    } finally {
      this.$wait.end(this._uid);
    }
  },
  methods: {
    ...mapActions("loadingStore", ["setLoading"]),
    ...mapActions("errorStore", ["addNewError"]),
    ...mapActions("companyGroupStore", ["getCompanyGroups"]),
    toggleRemove(traineeId) {
      this.model.remove = _xor(this.model.remove, [traineeId]);

      this.$emit("remove", this.model.remove);
    },
    handleMoveToGroup(traineeId, groupId) {
      this.model.move[traineeId] = groupId;
      this.$emit("move", this.model.move);
    },
    isReadyToBeRemoved(traineeId) {
      return this.model.remove.includes(traineeId);
    },
    isReadyToBeMoved(traineeId) {
      return this.model.move[traineeId] ? true : false;
    },
  },
};
</script>

<style></style>
